import { Marker, Popup } from "react-leaflet";
import { WomaMap } from "./WomaMap";
import { roleIcon } from "./roleMarkers";

// Recherche de prestataires : artisans disponibles autour du client
export const ArtisanSearchMap = ({ artisans, userPos, status, onRequest, specialties, onOpen }) => {
  const icon = roleIcon("artisan", { size: 36 });
  const located = artisans.filter((a) => a.base_latitude && a.base_longitude);
  return (
    <div className="space-y-2" data-testid="artisans-map-view">
      <WomaMap self={userPos} role="client" status={status} onRequest={onRequest} height={480} testId="artisans-search-map">
        {located.map((a) => (
          <Marker key={a.id} position={[a.base_latitude, a.base_longitude]} icon={icon}>
            <Popup>
              <div className="min-w-[160px]">
                <p className="font-bold">{a.full_name || "Artisan"}</p>
                <p className="text-xs">
                  {(a.specialties || []).slice(0, 2).map((s) => specialties.find((x) => x.key === s)?.label || s).join(" · ")}
                </p>
                {a.distance_km !== undefined && <p className="text-xs">{a.distance_km} km</p>}
                <button type="button" onClick={() => onOpen(a)} className="mt-2 text-xs font-bold text-[#003594]" data-testid={`artisan-map-open-${a.user_id}`}>
                  Voir profil →
                </button>
              </div>
            </Popup>
          </Marker>
        ))}
      </WomaMap>
      <p className="text-[11px] text-white/50" data-testid="artisans-map-count">
        {located.length} prestataire{located.length > 1 ? "s" : ""} disponible{located.length > 1 ? "s" : ""} sur la carte
      </p>
    </div>
  );
};
